import { useSelector } from "react-redux";
import MiljokontrollOversiktList from "./MiljokontrollOversiktList";

export default function MiljokontrollOversiktListContainer() {
  const miljokontroller = useSelector((state) => state.miljokontroller);
  return <MiljokontrollOversiktList miljokontroller={miljokontroller} />;
}
